export function parseCustomDateTime(dateTimeString) {
    let [datePart, timePart] = dateTimeString.split(' ');
    let [year, month, day] = datePart.split('-');
    let [hours, minutes, seconds] = timePart.split(':');

    return new Date(year, month - 1, day, hours, minutes, seconds);
}